export const FETCH_INVITES = 'FETCH_INVITES';
export const FETCH_USERS = 'FETCH_USERS';
export const USER_ALERT_DISPLAY = 'USER_ALERT_DISPLAY';
export const FETCH_LOCKED_USERS = 'FETCH_LOCKED_USERS';
